import styled from "@emotion/styled";

export const PictureContainer = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
  aspect-ratio: var(
    --picture-aspect-ratio-mobile,
    var(--picture-aspect-ratio-fallback)
  );

  & img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: var(--picture-img-object-fit, cover);
    opacity: var(--picture-img-opacity, 1);
    transition: var(--picture-img-transition, none);
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    aspect-ratio: var(
      --picture-aspect-ratio-tablet,
      var(--picture-aspect-ratio-fallback)
    );
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    aspect-ratio: var(
      --picture-aspect-ratio-desktop,
      var(--picture-aspect-ratio-fallback)
    );
  }
`;
